import {toast} from 'react-toastify';
import {isLoading} from '../../store/TableRedux/TableRedux';
import Batch from '../../http_request/Model/batch/Batch';
// eslint-disable-next-line import/no-cycle

export const getDataTable = (dataRoute, params, dispatch, getData) => {

    const newParams = {...params};
    if (!newParams.page_size) {
        newParams.page_size = 10;
    }
    if (!newParams.page) {
        newParams.page = 1;
    }

     Batch.request({
        beforeSend: () => {
            dispatch(isLoading(true));
        }, success: (result) => {
            // eslint-disable-next-line no-unused-expressions
            getData && getData(result);
        }, error: (error) => {
            toast.error(error?.message);
        }, final: () => {
            dispatch(isLoading(false));
        },
    }).addParams(newParams, true).getTableApi(dataRoute);
};









